exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "upd-unsubscribe {\n  display: block;\n  text-align: center;\n  padding: 40px;\n}\n\n  upd-unsubscribe > upd-icon {\n    width: 250px;\n    height: 250px;\n  }\n", ""]);

